import {
  type DeviceViewEntityId,
  isPacketDetailsEntity,
  isPathlookupDebugEntity,
} from 'components/DeviceView/deviceViewTypes';
import type { DeviceViewCommandFactory } from '../DeviceViewModel';

interface UpdateFiltersCommand {
  deviceViewEntityId: DeviceViewEntityId;
  tableId: string;
  filters: any;
}

export const updateFilters: DeviceViewCommandFactory<UpdateFiltersCommand> =
  (cmdContext) => (command) => {
    cmdContext.updateState((draft) => {
      const deviceViewEntity = draft.deviceViewEntities.find(
        (entity) => entity.id === command.deviceViewEntityId,
      );
      if (
        deviceViewEntity !== undefined &&
        !isPacketDetailsEntity(deviceViewEntity) &&
        !isPathlookupDebugEntity(deviceViewEntity)
      ) {
        deviceViewEntity.tableFilters[command.tableId] = command.filters;
      }
    });
  };
